import { useLocation } from 'react-router-dom';

import CampaignPlanForm from '@/components/campaigns/CampaignPlanForm/CampaignPlanForm';
import { CampaignPlanProvider } from '@/context/CampaignPlanProvider';
import { useGlobalStore } from '@/store/global';
import { getSessionByKeys } from '@/store/global/session/selectors';
import { getUserByKeys } from '@/store/global/user/selectors';

import type { MediaAdvertiserUserInterface } from 'sonata-static-storage/lib/schemas/mediaInfo/mediaAdvertiserUser.schema';
import type { CampaignPlan } from 'sonata-static-storage/lib/schemas/multiFlight/campaignPlan.schema';

export default function CampaignPlanSettingsModal() {
  const location = useLocation();
  const advertiser = location?.state?.advertiser as MediaAdvertiserUserInterface | undefined;
  const campaignPlan = location?.state?.campaignPlan as CampaignPlan | undefined;
  const { user: userId = '' } = useGlobalStore(store => getSessionByKeys(store, ['user']));
  const { country: userCountry } = useGlobalStore(store => getUserByKeys(store, ['country']));

  return (
    <CampaignPlanProvider advertiser={advertiser} campaignPlan={campaignPlan} userCountry={userCountry} userId={userId}>
      <CampaignPlanForm />
    </CampaignPlanProvider>
  );
}
